import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Segment, Form, Label, Input} from 'semantic-ui-react';
import {getPartPrice, getFactorValue} from '../../../common/util/partsUtils';
import {tabKeyCode} from '../../../common/constants/keyCodes';
import {Actions} from '../../../common/actions';

class FinancialInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {'calculatedFactor': 0};
  }

  componentDidUpdate(prevProps) {
    const {factors, fob, priceTde, partCode, priceFactors} = this.props;
    const {calculatedFactor} = this.state;
    if (prevProps?.factors && factors && prevProps?.factors?.productCode !== factors?.productCode) {
      this.handleFactorsChange(null, {'value': 0});
    }
    if (prevProps.partCode !== partCode) {
      this.setState({'calculatedFactor': 0});
    }
    if (factors && fob && (!calculatedFactor ||
      prevProps.priceTde !== priceTde || prevProps.priceFactors !== priceFactors)) {
      const factorIndex = priceFactors;
      this.setState({'calculatedFactor': getPartPrice(fob, {factors, factorIndex}, false)});
    }
  }

  getFactorOptions = (prefix) => {
    const {factors} = this.props;
    let factorValue;

    if (factors) {
      return [0, 1, 2, 3, 4].map((item) => {
        factorValue = getFactorValue(factors, prefix, item);
        return {'text': `Factor ${item + 1} - (${factorValue})`, 'value': item};
      });
    }

    return [];
  }

  handleChange = (event, data) => {
    const {name, value} = data;
    this.props.changePartsFormValue(name, value);
  }

  handleFactorsChange = (event, data) => {
    const {fob, factors} = this.props;
    const factorIndex = data.value;

    this.props.changePartsFormValue('priceFactors', data.value);
    this.props.changePartsFormValue('priceTde', getPartPrice(fob, {factors, factorIndex}, false));
    this.props.changePartsFormValue('pricePvp', getPartPrice(fob, {factors, factorIndex}, true));
  }

  handleFOBChange = (event, data) => {
    const {factors, priceFactors} = this.props;

    this.props.changePartsFormValue('fob', data.value);
    this.props.changePartsFormValue('priceTde', getPartPrice(data.value, {factors, priceFactors}, false));
    this.props.changePartsFormValue('pricePvp', getPartPrice(data.value, {factors, priceFactors}, true));
  }

  handleKeyDown = (event) => {
    const {fob, factors, priceFactors} = this.props;
    if (event.keyCode === tabKeyCode) {
      const factorIndex = priceFactors;
      this.props.changePartsFormValue('priceTde', getPartPrice(fob, {factors, factorIndex}, false));
      this.props.changePartsFormValue('pricePvp', getPartPrice(fob, {factors, factorIndex}, true));
    }
  }

  render() {
    const {loadingFactors, fob, cost, priceFactors, pricePvp, priceTde, allowFOBEdition} = this.props;
    const {calculatedFactor} = this.state;
    const isFactorPrice = calculatedFactor === Number(priceTde);

    return (
      <Segment secondary>
        <Form.Group widths='equal'>
          <Form.Select fluid
            label='Factor TDE'
            name='priceFactors'
            disabled={loadingFactors}
            loading={loadingFactors}
            options={this.getFactorOptions('factorWholesale')}
            value={priceFactors}
            onChange={this.handleFactorsChange}
          />
          <Form.Field className={(isFactorPrice && !loadingFactors) ? '' : 'price-tde-warning'}>
            <label><strong>Precio TDE</strong></label>
            <Input fluid required
              min='0.01'
              type='number'
              step='any'
              name='priceTde'
              value={priceTde}
              onKeyDown={this.handleKeyDown}
              onChange={this.handleChange}
            />
            {(!isFactorPrice && !loadingFactors) && (<span>Precio no coincide con factor TDE</span>)}
          </Form.Field>
          <Form.Select fluid
            label='Factor PVP'
            name='priceFactors'
            disabled={loadingFactors}
            loading={loadingFactors}
            options={this.getFactorOptions('factorRetail')}
            value={priceFactors}
            onChange={this.handleFactorsChange} />
          <Form.Field>
            <label><strong>Precio PVP</strong></label>
            <Input fluid required
              min='0.01'
              type='number'
              step='any'
              name='pricePvp'
              value={pricePvp}
              onChange={this.handleChange}
            />
          </Form.Field>
          <Form.Field>
            <label><strong>FOB</strong></label>
            <Input fluid required
              min='0.01'
              type='number'
              step='any'
              name='fob'
              readOnly={!allowFOBEdition}
              value={fob}
              onChange={this.handleFOBChange}
            />
          </Form.Field>
          <Form.Field>
            <label><strong>Costo Promedio</strong></label>
            <Label size='large'>{`$ ${cost}`}</Label>
          </Form.Field>
        </Form.Group>
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  const {values, factors, rejectionCode, pncLink, loadingFactors, allowFOBEdition} = state.partsMaster || {};
  const {fob, cost, priceFactors, pricePvp, priceTde, partCode} = values || {};

  return {
    loadingFactors,
    pncLink,
    rejectionCode,
    factors,
    fob,
    cost,
    priceFactors,
    pricePvp,
    priceTde,
    origin,
    allowFOBEdition,
    partCode,
  };
};

const {changePartsFormValue} = Actions;

export default connect(mapStateToProps, {changePartsFormValue})(FinancialInfo);
